<template>
    <v-list
        dense
        nav
    >
        <v-list-item-group
            v-model="selectedItem"
            color="primary"
        > 
            <div
                v-for="(menuItem, i) in menuItems"
                :key="i"  
            >
                <v-list-item
                    v-if="menuItem.visible"                                        
                    @click="display(menuItem)"                                    
                >
                    <v-list-item-icon >
                        <v-icon>
                            {{ menuItem.icon }}
                        </v-icon>
                    </v-list-item-icon>
    
                    <v-list-item-content>
                        <v-list-item-title >
                            {{ menuItem.text }}
                        </v-list-item-title>
                    </v-list-item-content>
    
                </v-list-item>
            </div>    

        </v-list-item-group>                
    </v-list>                 
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'AdminNavigation',

    created: function () {
        this.initialize();
    },

    computed: {
        ...mapGetters({
            menuOptions: 'admin/getMenuOptions',
            adminPermissions: 'auth/getAdminPermissions',
            formClassId: 'auth/getFormClassId',
            formLevel: 'auth/getFormLevel',
        })
    },

    data: () => ({      
        
        menuItems: [
            { text: 'Dashboard', icon: 'mdi-view-dashboard', submenu: false, menu: 'dashboard', visible: false },                     
            { text: 'Teachers', icon: 'mdi-account-group', submenu: false, menu: 'employees', visible: false },            
            { text: 'Students', icon: 'mdi-account-group', submenu: false, menu: 'students', visible: false },            
            { text: 'Subjects', icon: 'mdi-library', submenu: false, menu: 'studentSubjects', visible: false },            
            { text: 'Post Term Reports', icon: 'mdi-post', submenu: false, menu: 'postReports', visible: false },            
            { text: 'Edit\\View Term Details', icon: 'mdi-file-document-edit-outline', submenu: false, menu: 'termReports', visible: false },
            { text: 'Enter Marks', icon: 'mdi-keyboard', submenu: false, menu: 'enterMarks', visible: false },
            { text: 'Reports', icon: 'mdi-file-cabinet', submenu: true, menu: 'reports', visible: false },
            { text: 'Mark Book', icon: 'mdi-notebook', submenu: true, menu: 'markBook', visible: false },
            //{ text: 'Export Data', icon: 'mdi-database-export-outline', submenu: false, menu: 'exportData', visible: true },            
            //{ text: 'Import Students', icon: 'mdi-cloud-upload-outline', submenu: false, menu: 'importData',visible: false },
        ],       
        selectedItem: 0,       
    }),
    
    methods: {
        ...mapActions({
            registrationData: 'admin/downloadRegistrationData',
            getFormClasses: 'termReports/getFormClasses',
            // getCodedCommentsList: 'termReports/getCodedCommentsList',
            currentPeriod: 'termReports/getCurrentAcademicPeriod',
        }),

        ...mapMutations({
            setMenuOptions: 'admin/setMenuOptions',
            editViewTermReportsOverlay: 'termReports/setEditViewTermReportsOverlay',
            editViewTermReportsLoading: 'termReports/setEditViewTermReportsLoading',
            formClasses: 'termReports/setFormClasses',
            setFormClassesList: 'termReports/setFormClassesList',
        }),

        async initialize () {
            console.log('Initializing...');

            const permissions = JSON.parse(this.adminPermissions);

            let menuOptions = {};

            try {
                await this.currentPeriod();

            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            

            this.menuItems.forEach( menuItem => {
                if(menuItem.menu == 'students'  && this.formClassId){
                    menuItem.visible = true;
                    menuOptions[menuItem.menu] = false;
                }

                if(menuItem.menu == 'studentSubjects' && this.formLevel > 3){
                    menuItem.visible = true;
                    menuOptions[menuItem.menu] = false;
                }

                if(permissions.length == 0) return;

                let menuPermission = permissions.find(permission => permission.menu == menuItem.menu);
                if(!menuPermission) return; 

                menuItem.visible = true;
                menuOptions[menuItem.menu] = false;
            })

            //set first menu item to true
            menuOptions[Object.keys(menuOptions)[0]] = true;

            this.setMenuOptions(menuOptions);            
        },

        display(item){
            Object.keys(this.menuOptions).forEach(key => {
                this.menuOptions[key] = false;
            })
            this.$nextTick(() => {
                this.menuOptions[item.menu] = true;
            })
            this.setFormClasses();
            if(item.menu == 'termReports'){
                this.editViewTermReportsOverlay(true);
                this.editViewTermReportsLoading(true);                
            }
        },

        downloadExcel () {
            this.registrationData()
            .then(response => {                
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download','Registration Data.xlsx')
                document.body.appendChild(link)                
                link.click()
                this.setExportData(false);                
            })
        },

        async setFormClasses(){
            let response = null;

            try {

                response = await this.getFormClasses();            
                this.setFormClassesList(response.data);
                let formClasses = [];
                let form1Classes = [];
                let form2Classes = [];
                let form3Classes = [];
                let form4Classes = [];
                let form5Classes = [];
                let form6Classes = [];            
                response.data.forEach(record => {
                    switch(record.form_level){
                        case 1:
                        form1Classes.push({
                            title: record.class_id,
                            formLevel: 1,
                        });
                        break;
                        case 2:
                        form2Classes.push({
                            title: record.class_id,
                            formLevel: 2,
                        });
                        break;
                        case 3:
                        form3Classes.push({
                            title: record.class_id,
                            formLevel: 3,
                        });
                        break;
                        case 4:
                        form4Classes.push({
                            title: record.class_id,
                            formLevel: 4,
                        });
                        break;
                        case 5:
                        form5Classes.push({
                            title: record.class_id,
                            formLevel: 5,
                        });
                        break;
                        case 6:
                        form6Classes.push({
                            title: record.class_id,
                            formLevel: 6,
                        });
                        break;
                    }                
                });
                formClasses.push({
                    title: 'Form 1',
                    action: 'mdi-school',                
                    items: form1Classes
                });
                formClasses.push({
                    title: 'Form 2',
                    action: 'mdi-school',                
                    items: form2Classes
                });
                formClasses.push({
                    title: 'Form 3',
                    action: 'mdi-school',                
                    items: form3Classes
                });
                formClasses.push({
                    title: 'Form 4',
                    action: 'mdi-school',                
                    items: form4Classes
                });
                formClasses.push({
                    title: 'Form 5',
                    action: 'mdi-school',                
                    items: form5Classes
                });
                formClasses.push({
                    title: 'Form 6',
                    action: 'mdi-school',                
                    items: form6Classes
                });            
                this.formClasses(formClasses);
                // await this.getCodedCommentsList();
                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            
            
        },
        
        
    }
}
</script>

<style scoped>
    ::v-deep .v-list-item__title{
        white-space: pre-wrap;
    }
</style>